import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:false,
    token:'',
    username:'',
    password:'',
    userAccount:'',
    isShowScratch3d:true,
  },
  getters: {
  },
  mutations: {
    SETSCRATCH3D(state,val){
      state.isShowScratch3d = val;
    },
    updateToken(state,val){
      state.isLogin = val;
    },
    setToken(state,val){
      state.token = val;
    },
     setPhone(state,val){
      state.userAccount = val;
    },
    SETUSERNAME(state,val){
      state.username = val;
    },
    PASSWORD(state,val){
      state.password = val;
    }
  },
  actions: {
  },
  modules: {
  }
})
